/* eslint-disable import/prefer-default-export */
import { handleActions } from 'redux-actions';
import { READY } from '../../actions/types';

const INITIAL_STATE = null;

export const reducer = handleActions(
  {
    [READY]: (state, { payload }) => (payload ? payload.showNotes : ''),
  },
  INITIAL_STATE,
);
